export default {
  survey: state => state.survey
}



// WEBPACK FOOTER //
// ./src/store/modules/clientsurvey/getters.js